import React from 'react';
import axios from 'axios';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const EclairagesTab = ({ pendingComments, setPendingComments, setActiveTab, token, t }) => {
  return (
    <div>
      <h3 style={{
        fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37',
        letterSpacing: 2, textTransform: 'uppercase', marginBottom: 20,
        textAlign: 'center', fontWeight: 400,
      }}>
        {t('dash_eclairages')}
      </h3>
      <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', textAlign: 'center', marginBottom: 24, lineHeight: 1.6 }}>
        {t('mod_description')}
        {' '}{t('mod_visible_desc')}
      </p>

      {pendingComments.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 20px' }}>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 14, color: '#D4AF37', fontStyle: 'italic' }}>
            {t('mod_no_pending')}
          </p>
          <p style={{ fontFamily: "'Georgia', serif", fontSize: 12, color: '#FAF3E0', marginTop: 8 }}>
            {t('mod_no_pending_sub')}
          </p>
        </div>
      ) : (
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          {pendingComments.map(c => (
            <div
              key={c.id}
              data-testid={`moderation-comment-${c.id}`}
              style={{
                padding: '16px', marginBottom: 12, borderRadius: 10,
                backgroundColor: 'rgba(212,175,55,0.03)',
                border: c.status === 'pending' ? '1px solid rgba(212,175,55,0.2)' : '1px solid rgba(212,175,55,0.06)',
                opacity: c.status === 'approved' ? 0.6 : 1,
              }}
            >
              <div style={{ display: 'flex', gap: 12, marginBottom: 8 }}>
                {c.photo_id && (
                  <img
                    src={`${API}/photos/${c.photo_id}/thumbnail?token=${token}`}
                    alt=""
                    data-testid={`moderation-thumb-${c.id}`}
                    style={{
                      width: 56, height: 56, borderRadius: 8, objectFit: 'cover',
                      border: '1px solid rgba(212,175,55,0.15)',
                      flexShrink: 0,
                    }}
                    onError={e => { e.target.style.display = 'none'; }}
                  />
                )}
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <span style={{ fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37', fontWeight: 600 }}>
                        {c.guest_name}
                      </span>
                      {(c.photo_caption || c.photo_filename) && (
                        <span style={{ fontFamily: "'Georgia', serif", fontSize: 11, color: '#FAF3E0', marginLeft: 10, fontStyle: 'italic' }}>
                          sur "{c.photo_caption || c.photo_filename}"
                        </span>
                      )}
                    </div>
                    <span style={{
                      fontFamily: "'Georgia', serif", fontSize: 10, padding: '2px 10px', borderRadius: 10,
                      backgroundColor: c.status === 'pending' ? 'rgba(212,175,55,0.1)' : c.status === 'approved' ? 'rgba(46,204,113,0.1)' : 'rgba(192,57,43,0.1)',
                      color: c.status === 'pending' ? '#D4AF37' : c.status === 'approved' ? '#2ecc71' : '#e74c3c',
                      border: `1px solid ${c.status === 'pending' ? 'rgba(212,175,55,0.2)' : c.status === 'approved' ? 'rgba(46,204,113,0.2)' : 'rgba(192,57,43,0.2)'}`,
                      flexShrink: 0,
                    }}>
                      {c.status === 'pending' ? t('mod_pending') : c.status === 'approved' ? t('mod_approved') : t('mod_reject')}
                    </span>
                  </div>
                  {c.created_at && (
                    <span style={{ fontFamily: "'Georgia', serif", fontSize: 10, color: '#FAF3E0', display: 'block', marginTop: 2 }}>
                      {new Date(c.created_at).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </span>
                  )}
                </div>
              </div>

              {c.has_audio && (
                <button
                  data-testid={`moderation-play-${c.id}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    const btn = e.currentTarget;
                    if (btn._audio && !btn._audio.paused) {
                      btn._audio.pause();
                      btn._audio.currentTime = 0;
                      btn._audio = null;
                      btn.querySelector('span').textContent = 'Ecouter';
                      return;
                    }
                    const a = new Audio(`${API}/eclaireur/audio/${c.id}`);
                    btn._audio = a;
                    btn.querySelector('span').textContent = 'Arreter';
                    a.play();
                    a.onended = () => { btn._audio = null; btn.querySelector('span').textContent = 'Ecouter'; };
                  }}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6,
                    fontFamily: "'Georgia', serif", fontSize: 12, color: '#D4AF37',
                    background: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.2)',
                    borderRadius: 16, padding: '5px 14px', cursor: 'pointer',
                    marginBottom: 8,
                  }}
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="#D4AF37"><polygon points="5 3 19 12 5 21"/></svg>
                  <span>{t('ecl_listen')}</span>
                </button>
              )}

              {c.text && c.text !== '(message vocal)' && (
                <p style={{
                  fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37',
                  fontStyle: 'italic', lineHeight: 1.6, marginBottom: 10,
                }}>
                  "{c.text}"
                </p>
              )}

              {c.status === 'pending' && (
                <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                  <button
                    data-testid={`approve-comment-${c.id}`}
                    onClick={async () => {
                      try {
                        await axios.post(`${API}/eclaireur/comments/${c.id}/approve`, {}, { headers: { Authorization: `Bearer ${token}` } });
                        setPendingComments(prev => prev.map(x => x.id === c.id ? { ...x, status: 'approved' } : x));
                      } catch { /* silent */ }
                    }}
                    style={{
                      fontFamily: "'Georgia', serif", fontSize: 12, color: '#2ecc71',
                      backgroundColor: 'rgba(46,204,113,0.08)', border: '1px solid rgba(46,204,113,0.25)',
                      padding: '6px 18px', borderRadius: 6, cursor: 'pointer',
                    }}
                  >
                    {t('mod_approve')}
                  </button>
                  <button
                    data-testid={`reject-comment-${c.id}`}
                    onClick={async () => {
                      try {
                        await axios.post(`${API}/eclaireur/comments/${c.id}/reject`, {}, { headers: { Authorization: `Bearer ${token}` } });
                        setPendingComments(prev => prev.filter(x => x.id !== c.id));
                      } catch { /* silent */ }
                    }}
                    style={{
                      fontFamily: "'Georgia', serif", fontSize: 12, color: 'rgba(192,57,43,0.7)',
                      backgroundColor: 'rgba(192,57,43,0.06)', border: '1px solid rgba(192,57,43,0.15)',
                      padding: '6px 18px', borderRadius: 6, cursor: 'pointer',
                    }}
                  >
                    {t('mod_reject')}
                  </button>
                </div>
              )}
              {/* Supprimer un commentaire deja traite */}
              {c.status !== 'pending' && (
                <button
                  data-testid={`delete-comment-${c.id}`}
                  onClick={async () => {
                    try {
                      await axios.post(`${API}/eclaireur/comments/${c.id}/reject`, {}, { headers: { Authorization: `Bearer ${token}` } });
                      setPendingComments(prev => prev.filter(x => x.id !== c.id));
                    } catch { /* silent */ }
                  }}
                  style={{
                    fontFamily: "'Georgia', serif", fontSize: 11, color: '#D4AF37',
                    backgroundColor: 'transparent', border: '1px solid rgba(212,175,55,0.1)',
                    padding: '4px 14px', borderRadius: 6, cursor: 'pointer', marginTop: 4,
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.color = 'rgba(180,60,60,0.7)'; e.currentTarget.style.borderColor = 'rgba(180,60,60,0.2)'; }}
                  onMouseLeave={e => { e.currentTarget.style.color = '#D4AF37'; e.currentTarget.style.borderColor = '#D4AF37'; }}
                >
                  Retirer de la liste
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EclairagesTab;
